<template>
  <div id="userList">
    <div class="searchContent">
      <!--<div class="p_select el_select_org">
                <div class="search_label">检测站点</div>
                <el-select v-model="orgId" clearable filterable placeholder="请选择检测站点" @change="orgChange">
                    <el-option v-for="item in orgArr" :key="item.orgId" :label="item.orgName" :value="item.orgId"></el-option>
                </el-select>
            </div>
            <div class="p_select">
                <a  class="search_btn" @click="getListData">查询</a>
            </div>-->
      <div class="p_select" style="float: right">
        <a  class="add_btn" @click="addItem"
          ><i class="el-icon-plus"></i>新增</a
        >
      </div>
    </div>

    <div class="list_box">
      <div class="sa_box">
        <div class="top">
          <div class="dot">
            <div class="spot"></div>
            <span>部位</span>
          </div>
          <!--<a  class="reset" @click="resetData">重置</a>-->
        </div>
        <div class="item">
          <el-radio-group v-model="positionId">
            <el-radio
              v-for="item in positionList"
              :key="item.index"
              @change="getListData"
              :label="item.positionId"
              >{{ item.positionName }}({{ item.num }})
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="data_box">
        <!--:cell-class-name="delLine"-->
        <el-table :data="marketingConfigList" :height="winHeight">
          <el-table-column
            prop="marketingId"
            label="ID"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="content"
            label="内容"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            label="生效日期"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            label="失效日期"
            align="left"
          ></el-table-column>
          <el-table-column prop="couponUrl" align="left" label="优惠券链接">
            <template slot-scope="scope">
              <a :href="scope.row.couponUrl" target="_blank" style="color: #606266;">{{scope.row.couponUrl}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="orgName" align="left" label="图片">
            <template slot-scope="scope">
              <a  @click="showBigImg(scope.row.imgUrl)">
                <img
                  style="height: 80px"
                  class="el-image__inner"
                  :src="scope.row.imgUrl"
                />
              </a>
            </template>
          </el-table-column>
          <el-table-column label="营销状态" align="left">
            <template slot-scope="scope">
              <span
                v-show="scope.row.marketingState === 1"
                style="color: #f56c6c"
                >已过期</span
              >
              <span
                v-show="scope.row.marketingState === 2"
                style="color: #909399"
                >未生效</span
              >
              <span
                v-show="scope.row.marketingState === 3"
                style="color: #67c23a"
                >生效中</span
              >
            </template>
          </el-table-column>
          <!-- @yu -->
          <el-table-column label="检出状态" align="left">
            <template slot-scope="scope">
              <div v-show="scope.row.isNormal === 1" style="color: #29d3bf">
                正常
              </div>
              <div
                v-show="scope.row.isCaution === 1"
                style="color: rgba(225, 189, 62, 1)"
              >
                警示
              </div>
              <div v-show="scope.row.isUrgency === 1" style="color: #e04066">
                紧急
              </div>
              <div
                v-show=" !scope.row.isNormal && !scope.row.isCaution && !scope.row.isUrgency "
              >
                暂无
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="left">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isUsing"
                active-color="#13ce66"
                inactive-color="#F56C6C"
                active-value="1"
                inactive-value="0"
                active-text="启用"
                inactive-text="禁用"
                @change="changIsUsing(scope.row, scope.row.isUsing)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-drawer
      title="添加方案"
      :visible.sync="showAddDrawer"
      size="50%"
      direction="rtl"
    >
      <el-form
        ref="marketingForm"
        :model="marketingForm"
        label-width="100px"
        style="height: 300px"
      >
        <el-form-item label="部位名称:" required>
          <el-select
            v-model="marketingForm.positionId"
            clearable
            filterable
            placeholder="请选择部位"
            style="width: 100%"
          >
            <el-option
              v-for="item in positionAllList"
              :key="item.positionId"
              :label="item.positionName"
              :value="item.positionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方案图:" required>
          <div class="img_box">
            <div class="upload-img" style="height: 80px">
              <input type="file" ref="marketingImg" @change="uploadImg()" />
              <img v-if="fileImgUrl" :src="fileImgUrl" class="img" ref="img" />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <p style="font-size: 12px; color: #b9b9b9; text-align: left">
            为了您的预览效果更佳，请上传 800*600 的图片
          </p>
        </el-form-item>
      </el-form>
      <div class="position_box_btn">
        <a class="sure_btn" @click="submitAdd">确认</a>
        <a class="cancel_btn" @click="noUpdateData">取消</a>
      </div>
    </el-drawer>
    <el-drawer
      title="添加方案内容"
      :visible.sync="showAddDrawerDetail"
      size="50%"
      direction="rtl"
    >
      <el-form
        ref="marketingForm"
        :rules="rules"
        :model="marketingForm"
        label-width="100px"
        style="height: 300px"
      >
        <el-form-item label="部位名称:" prop="positionId" required>
          <el-select
            v-model="marketingForm.positionId"
            disabled
            placeholder="请选择部位"
            style="width: 100%"
          >
            <el-option
              v-for="item in positionAllList"
              :key="item.positionId"
              :label="item.positionName"
              :value="item.positionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方案图:" required>
          <div class="img_box">
            <div class="upload-img" style="height: 80px">
              <img :src="fileImgUrl" class="img" ref="img" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="方案标题:" prop="title" required>
          <el-input
            v-model="marketingForm.title"
            placeholder="请输入方案标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="方案内容:" prop="content" required>
          <el-input
            type="textarea"
            v-model="marketingForm.content"
            placeholder="请输入方案内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="生效日期:" required>
          <el-form-item prop="startTime">
            <el-date-picker
              v-model="marketingForm.startTime"
              type="date"
              placeholder="选择生效日期"
              prefix-icon="''"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item label="失效日期:" required>
          <el-form-item prop="endTime">
            <el-date-picker
              v-model="marketingForm.endTime"
              type="date"
              placeholder="选择失效日期"
              prefix-icon="''"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-form-item>

        <el-form-item label="优惠券链接:" prop="couponUrl">
          <el-input
                  v-model="marketingForm.couponUrl"
                  placeholder="请输入优惠券链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="检出状态:">
          <el-checkbox-group
            v-model="type"
            class="checkList"
            @change="checkboxChange"
          >
            <el-checkbox label="正常" ref="checkOne"></el-checkbox>
            <el-checkbox label="警示" ref="checkTwo"></el-checkbox>
            <el-checkbox label="紧急" ref="checkThree"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="position_box_btn">
        <a class="sure_btn" @click="submitAddDetail('marketingForm')"
          >确认新增</a
        >
        <a class="cancel_btn" @click="showAddDrawerDetail = false">取消</a>
      </div>
    </el-drawer>
    <el-dialog title="查看图片" :visible.sync="showBigImgDialog" width="60%">
      <img :src="bigImgUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import net from "../../assets/js/public";
export default {
  name: "PowerBI",
  data() {
    return {
      signInfo: "",
      orgId: "",
      orgArr: [], //所有集团下所有站点

      positionId: "", // 选中的
      positionList: [], //全部的

      marketingConfigList: [],
      winHeight: "200",
      showAddDrawer: false,
      marketingForm: {
        orgId: "",
        positionId: "",
        fileImg: "",
        imageId: "",
        title: "",
        content: "",
        startTime: "",
        endTime: "",
        couponUrl: "",
      },
      type: [],
      rules: {
        positionId: [
          { required: true, message: "请选择部位", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入方案标题", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入方案内容", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择生效日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择失效时间",
            trigger: "change",
          },
        ],
      },

      fileImgUrl: "",
      positionAllList: [], // 所有部位
      showAddDrawerDetail: false,
      showBigImgDialog: false,
      bigImgUrl: "",
    };
  },
  created() {
    let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
    this.signInfo = signInfo;

    if (signInfo.orgId > 0) {
      this.orgId = signInfo.orgId;
      this.orgName = signInfo.orgName;
    }

    this.queryPositionMarketingValid();
  },
  methods: {
    // 查询站点部位营销生效部位数量
    queryPositionMarketingValid() {
      net
        .request(
          "admin/manage/organizationMarketing/queryPositionMarketingValid",
          "post",
          { orgId: this.orgId }
        )
        .then((res) => {
          if (res.code === 0) {
            this.positionList = res.data; //显示的
            if (res.data.length > 0) {
              this.positionId = this.positionId
                ? this.positionId
                : res.data[0].positionId;
              this.getListData();
            }
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
    },
    // 获取所有部位
    getPositionList() {
      net.request("admin/manage/parts/getPositionList", "post").then((res) => {
        if (res.code === 0) {
          this.positionAllList = res.data;
        } else {
          net.message(this, res.msg, "warning");
        }
      });
    },
    // 重置
    /*resetData(){
        this.positionId = ""
        this.getListData()
      },*/
    addItem() {
      this.showAddDrawer = true;
      this.getPositionList();
      this.marketingForm = {};
      this.fileImgUrl = "";
      if (this.$refs.marketingImg) this.$refs.marketingImg.value = "";
    },
    // 上传图片
    uploadImg() {
      const inputFile = this.$refs.marketingImg.files[0];
      let res = "";
      let that = this;
      if (inputFile) {
        let files = /image/.test(inputFile.type);
        if (!files) {
          alert("请确保文件为图像类型");
          return false;
        }
        if (inputFile.size > 1024 * 1024 * 20) {
          net.message(this, "请上传小于 20M 的图片 ！", "warning");
          return;
        }
        this.marketingForm.fileImg = inputFile;
        const reader = new FileReader();
        res = reader.readAsDataURL(inputFile);
        reader.onloadend = function () {
          const strBase64 = reader.result.substring(0);
          that.fileImgUrl = strBase64;
        };
      } else {
        return;
      }
    },
    submitAdd() {
      let marketingForm = this.marketingForm;
      if (
        marketingForm.fileImg == null ||
        marketingForm.positionId == null ||
        marketingForm.fileImg == "" ||
        marketingForm.positionId == ""
      ) {
        net.message(this, "请选择部位和图片", "error");
        return;
      }
      const param = new FormData();
      param.append("file", marketingForm.fileImg);
      param.append("orgId", this.orgId);
      param.append("positionId", marketingForm.positionId);

      let url = net.baseUrl + "admin/manage/organizationMarketing/updateImage";
      axios
        .post(url, param, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: this.signInfo.token,
          },
        })
        .then((res) => {
          if (res.data.code === 0) {
            let imgUrl =
              net.baseUrl +
              "admin/manage/organizationMarketing/getImage?imageId=" +
              res.data.data;
            this.marketingForm.fileImg = imgUrl;
            this.marketingForm.imageId = res.data.data;
            net.message(
              this,
              "图片上传成功，请继续为该图片添加内容",
              "success"
            );
            this.showAddDrawerDetail = true;
          } else {
            net.message(this, res.data.msg, "error");
          }
        });
    },
    submitAddDetail(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          let { positionId, imageId, title, content, startTime, endTime, couponUrl } =
            _this.marketingForm;
          const params = {
            orgId: _this.orgId,
            positionId,
            imageId,
            title,
            content,
            couponUrl,
            startTime: moment(startTime).format("YYYY-MM-DD"),
            endTime: moment(endTime).format("YYYY-MM-DD"),
            isUsing: 1,
            isNormal: this.$refs.checkOne.isChecked === false ? "0" : "1",
            isCaution: this.$refs.checkTwo.isChecked === false ? "0" : "1",
            isUrgency: this.$refs.checkThree.isChecked === false ? "0" : "1",
          };
          net
            .request(
              "admin/manage/organizationMarketing/addOrgPositionMarketingInfo",
              "post",
              null,
              params
            )
            .then((res) => {
              if (res.code === 0) {
                net.message(_this, res.msg, "success");
                _this.queryPositionMarketingValid();
                _this.noUpdateData();
              } else {
                net.message(_this, res.msg, "error");
              }
            });
        } else {
          return false;
        }
      });
    },
    noUpdateData() {
      this.showAddDrawer = false;
      this.showAddDrawerDetail = false;
    },
    getListData() {
      if (
        this.orgId == null ||
        this.orgId == "" ||
        this.positionId == null ||
        this.positionId == ""
      ) {
        net.message(this, "请选择站点和部位", "warning");
        return;
      }
      const params = {
        orgId: this.orgId,
        positionId: this.positionId,
      };
      net
        .request(
          "admin/manage/organizationMarketing/queryMarketingConfigList",
          "post",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            let marketingConfigList = res.data;

            let dateNow = new Date();
            const dateNowStamp = moment(dateNow).valueOf();

            marketingConfigList.forEach((item) => {
              item.isUsing = item.isUsing + "";
              item.imgUrl = `${net.baseUrl}admin/manage/organizationMarketing/getImage?imageId=${item.imageId}`;

              if (moment(item.endTime).valueOf() < dateNowStamp) {
                // 已失效
                item.marketingState = 1;
              } else if (moment(item.startTime).valueOf() > dateNowStamp) {
                //未生效
                item.marketingState = 2;
              } else {
                // 生效中
                item.marketingState = 3;
              }
            });

            this.marketingConfigList = marketingConfigList;
            const windiwHight =
              document.documentElement.clientHeight ||
              document.body.clientHeight; // 可视屏幕高度
            this.winHeight = windiwHight - 176;
          } else {
            net.message(this, res.msg, "error");
          }
        });
    },
    changIsUsing(row, isUsing) {
      const params = {
        marketingId: row.marketingId,
        isUsing: isUsing * 1,
      };
      net
        .request(
          "admin/manage/organizationMarketing/updateOrgPositionMarketingStatus",
          "post",
          params
        )
        .then((res) => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
            this.queryPositionMarketingValid();
          } else {
            net.message(this, res.msg, "error");
          }
        });
    },
    showBigImg(imgUrl) {
      this.bigImgUrl = imgUrl;
      this.showBigImgDialog = true;
    },
    //checkboxChange
    checkboxChange(e) {
      this.type = e;
      this.marketingForm.types = e;
    },
  },
};
</script>

<style lang="less" scoped>
#userList {
  width: calc(100% - 24px);
  height: calc(100% - 36px);
  padding-left: 24px;
  padding-top: 24px;
  display: flex;
  flex-flow: column;
  .searchContent {
    background: #fff;
    padding-left: 12px;
    padding-top: 12px;
    border-radius: 8px;
    .p_select {
      display: flex;
      padding: 0 12px 12px 0;
      font-size: 12px;
      float: left;
      .search_label {
        font-family: "PingFang SC";
        font-style: normal;
        margin-right: 12px;
        font-weight: 500;
        font-size: 14px;
        line-height: 40px;
        color: #787e86;
        white-space: nowrap;
      }

      .el-input,
      .el-select {
        width: 160px;
      }
    }
    .search_btn {
      width: 76px;
      height: 36px;
      line-height: 36px;
      background: #2b54fc;
      box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
      border-radius: 4px;
      color: #ffffff;
      font-size: 14px;
    }
    .add_btn {
      width: 76px;
      height: 36px;
      line-height: 36px;
      background: rgba(148, 170, 204, 0.08);
      border: 1px solid #2b54fc;
      border-radius: 4px;
      font-size: 14px;
      color: #2b54fc;
    }
  }
  .list_box {
    display: flex;
    height: calc(100% - 48px);
    .sa_box {
      width: 170px;
      height: calc(100% - 12px);
      overflow-y: initial;
      overflow-x: hidden;
      margin-top: 12px;
      background: #ffffff;
      border-radius: 8px;
      .top {
        overflow: hidden;
        .dot {
          float: left;
          display: inline-flex;
          .spot {
            width: 4px;
            height: 10px;
            margin-top: 12px;
            margin-left: 12px;
            background: #2b54fc;
            border-radius: 3px;
          }
          span {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 36px;
            color: #0d0e12;
            margin-left: 8px;
          }
        }
        .reset {
          float: right;
          margin-top: 12px;
          margin-right: 12px;
          font-weight: 400;
          font-size: 12px;
          color: #2b54fc;
        }
      }
      .item {
        /deep/ .el-radio {
          width: 100%;
          text-align: left;
          margin-left: 12px;
          line-height: 30px;
          .el-radio__inner {
            border-radius: 0 !important;
          }
          .el-radio__input.is-checked .el-radio__inner::after {
            background: #2b54fc;
            content: "";
            width: 9px;
            height: 5px;
            border: 2px solid white;
            border-top: transparent;
            border-right: transparent;
            text-align: center;
            display: block;
            position: absolute;
            top: 2px;
            left: 1px;
            vertical-align: middle;
            transform: rotate(-45deg);
            border-radius: 0px;
            background: none;
          }
        }
      }
    }
    .data_box {
      width: calc(100% - 182px);
      height: 100%;
      margin-top: 12px;
      border-radius: 8px;
      overflow: hidden;
      margin-left: 12px;
    }
  }

  .img_box {
    text-align: left;
    .upload-img {
      display: flex;
      img {
        width: 80px;
        height: 60px;
      }
    }
  }
  .checkList {
    width: 40%;
    position: relative;
    display: flex;
  }
}
</style>
